//dependencias
import React, { Component } from 'react';

//componentes
import AutorizarCT from './autorizarCT'

class Index extends Component {

    render(){
        return(
            <div>
                <AutorizarCT />
            </div>
        );
    }

}
export default Index;